$(document).ready(function () {
    switchDiv();
  
    $("li:first-child").addClass("first");
    $("li:last-child").addClass("last");

    $('[href="#"]').attr("href", "javascript:;");

    $(".menu-Bar").click(function () {
        $(this).toggleClass("open");
        $(".menuWrap").toggleClass("open");
        $("body").toggleClass("ovr-hiddn");
    });

    $(".loginUp").click(function () {
        $(".LoginPopup").fadeIn();
        $(".overlay").fadeIn();
    });

    $(".signUp").click(function () {
        $(".signUpPop").fadeIn();
        $(".overlay").fadeIn();
    });

    $(".closePop,.overlay").click(function () {
        $(".popupMain").fadeOut();
        $(".overlay").fadeOut();
    });

    $(".next-step").click(function () {
        $(".step1").fadeOut();
        $(".next-step").fadeOut();
        $(".step2").fadeIn();
        $(".back-step").fadeIn();
    }); 

    $(".back-step").click(function () {
        $(".step2").fadeOut();
        $(".back-step").fadeOut();
        $(".step1").fadeIn();
        $(".next-step").fadeIn();
    }); 

    // $(".search-box").click(function () {
    //     $(".search-result").slideDown();
    //     $(".search-result").delay(5000).slideUp();
    // }); 

    $('.promo-search').click(function () {
        $(".popup").fadeIn();
        $(".overlay").fadeIn();

    });

    $('.closePop,.overlay').click(function () {
        $('.popup').fadeOut();
        $('.overlay').fadeOut();
    });

    $('.ico-list li').click(function () {
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
    });

    $(".menu .menu-item-has-children").addClass("dropdown-nav ");
    $(".menu .menu-item-has-children ul.sub-menu").addClass("dropdown");

     /* Tabbing Function */
     $("[data-targetit]").on("click", function(e) {
        $(this).addClass("active");
        $(this)
            .siblings()
            .removeClass("active");
        var target = $(this).data("targetit");
        $("." + target)
            .siblings('[class^="box-"]')
            .hide();
        $("." + target).fadeIn();
        $(".tabViewList").slick("setPosition", 0);
    });

  
    // Accordian
    // $('.accordion-list > li > .answer').hide();
    // $('.accordion-list > li > h3, .accordion-list > li > span').click(function () {
    //     if ($(this).parent().hasClass("active")) {
    //         $(this).parent().removeClass("active").find(".answer").slideUp();
    //     } else {
    //         $(".accordion-list > li.active .answer").slideUp();
    //         $(".accordion-list > li.active").removeClass("active");
    //         $(this).parent().addClass("active").find(".answer").slideDown();
    //     }
    //     return false;
    // });


  
$('.accordion-list > li > .answer').hide();
$('.accordion-list > li > .answer').addClass('animate__animated');

$('.accordion-list > li > h3, .accordion-list > li > span').click(function () {
    var $parent = $(this).parent();
    var $answer = $parent.find('.answer');

    if ($parent.hasClass('active')) {
        $parent.removeClass('active');
        $answer.removeClass('animate__fadeIn').addClass('animate__fadeOut');
    } else {
        $('.accordion-list > li.active').removeClass('active').find('.answer').removeClass('animate__fadeIn');
        $parent.addClass('active');
        $answer.removeClass('animate__fadeOut').addClass('animate__fadeIn');
    }

    return false;
});

  
    $("li.dropdown-nav").hover(function () {
        $(this)
            .children("ul")
            .stop(true, false, true)
            .slideToggle(300);
    });

    $(".searchBtn").click(function () {
        $(".searchWrap").addClass("active");
        $(".overlay").fadeIn("active");
        $(".searchWrap input").focus();
        $(".searchWrap input").focusout(function (e) {
            $(this)
                .parents()
                .removeClass("active");
            $(".overlay").fadeOut("active");
            $("body").removeClass("ovr-hiddn");
        });
    });

    $(".index-slider").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        arrow: true, 
    });

    $(".result-slider").slick({
        dots: false,
        infinite: true,
        speed: 8000,
        slidesToShow: 6,
        slidesToScroll:1,
        arrows: false, 
        autoplay:true,
        autoplaySpeed:0,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              // adaptiveHeight:true,
              speed: 500,
              autoplaySpeed:3000,
            }
          }
        ]
    });



    $(".index-slider-promote").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        arrows: true, 
    });


    $(".index-slider-clientele").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        arrows: false, 
        responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                // adaptiveHeight:true,
                dots: true,
                // autoplay:true,
                // autoplaySpeed:3000,
              }
            }
        ]
    });

    
    $(".index-slider-clients").slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        arrows: true, 
        autoplay:true,
        autoplaySpeed:3000,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              // adaptiveHeight:true,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              autoplay:false,
              // adaptiveHeight:true,
              arrows:true,
            }
          }
        ]
    });



    $(".index-slider-testimonial").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        arrow: true, 
    });

    $(".casestudies-slider").slick({
        dots: true,
        arrows:false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        autoplay:true,
        autoplaySpeed:3000,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              // adaptiveHeight:true,
              autoplay:false,
            }
          }
        ]
    });

    $(".press-slider").slick({
        dots: false,
        arrows:false,
        infinite: true,
        speed: 5000,
        slidesToShow: 6,
        autoplay:true,
        autoplaySpeed:0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              adaptiveHeight:true,
            }
          },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
              }
            }
          ]
    });

  

    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        arrows: false,
        focusOnSelect: false,
        infinite: true,

    });

    /* Top Scroll */
    // $('body').on('click', '.scrolldown-fl', function() {
    //     goToScroll('awardSec');
    // });
});

$(window).on("scroll touchmove", function() {
    $("header").toggleClass("stickyOpen", $(document).scrollTop() > 150);
});

$(window).on("load", function () {
    var currentUrl = window.location.href.substr(
        window.location.href.lastIndexOf("/") + 1
    );
    $("ul.menu li a").each(function () {
        var hrefVal = $(this).attr("href");
        if (hrefVal == currentUrl) {
            $(this).removeClass("active");
            $(this)
                .closest("li")
                .addClass("active");
            $("ul.menu li.first").removeClass("active");
        }
    });
});

/* RESPONSIVE JS */
if ($(window).width() < 824){ }

function switchDiv() {
    var $window = $(window).outerWidth();
    if ($window <= 768) {
        $(".topAppendTxt").each(function () {
            var getdtd = $(this)
                .find(".cloneDiv")
                .clone(true);
            $(this)
                .find(".cloneDiv")
                .remove();
            $(this).append(getdtd);
        });
    }
}

function goToScroll(e) {
    $("html, body").animate({
        scrollTop: $("." + e).offset().top
    },
        1000
    );
}


$(document).ready(function () {
    $('.popdynamic').click(function () {
        $('.centercont.static').addClass('d-none');
        $('.centercont.dynamic').removeClass('d-none');
        $('.overlay').fadeIn();
        $('#popdynamic').fadeIn();
        $('.LoginPopup').addClass('price-margin');

        var packtitle = $(this).closest('.pckg').find(" .title").html();
        var packprice = $(this).closest('.pckg').find(".price .amount").html();



        var thisrel = $(this).attr('rel');
        $('input[name="pkg_key"]').val(thisrel);
        $('#popupform input#popuppackage').val(thisrel);
        $(".centercont.dynamic h3 span").html(packtitle);
        $(".centercont h4").html("In Just <span>" + packprice + "</span>");
    });



    $('.popbtn2').click(function () {
        $('.centercont.static').addClass('d-none');
        $('.centercont.dynamic').removeClass('d-none');
        $('.overlay').fadeIn();
        $('#popdynamic').fadeIn();
        $('.LoginPopup').addClass('price-margin');
        var packtitle = $(this).closest('.pckg2').find(".label").html();
        var packprice = $(this).closest('.pckg2').find(".price").html();
        var thisrel = $(this).attr('rel');
        $('input[name="pkg_key"]').val(thisrel);
        $('#popupform input#popuppackage').val(thisrel);
        $(".centercont.dynamic h3 span").html(packtitle);
        $(".centercont h4").html("In Just <span>" + packprice + "</span>");
    });

    $('.closeico,.overlay').click(function () {

        $('.popupmain').fadeOut();
        $('.overlay').fadeOut();


    });

    $('.popstatic').click(function () {
        $('.centercont.static').removeClass('d-none');
        $('.centercont.dynamic').addClass('d-none');
        $('#popstatic').fadeIn();
        $('.overlay').fadeIn();


        var orgtexts = '$99';
        //  $(".centercont h3 span").text('Start your Trademark Registration Now');
        $(".centercont h4").html("in Just <span>" + orgtexts + "</span>");
    });

    $(window).scroll(function () {
        var header = $('header'),
            scroll = $(window).scrollTop();

        if (scroll >= 1) {
            header.addClass('sticky');
        }
        if (scroll <= 0) {
            header.removeClass('sticky');
        }

    });

});



  $(".testi-slider-2").slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 3,
    responsive: [
        {
            breakpoint: 1025,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 885,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
                cssEase: 'ease',
                slidesToShow: 1,
                slidesToScroll: 1,
              
            }
          }
      ]
});


if ($(window).width() > 1200) {
    $('.has-child.hover').hover(function() {
        $('.has-child').not($(this)).find('.dropdown').stop(true,false,true).slideUp(500);
        $('.has-child').not($(this)).find('.chev').removeClass('rotate');
        $(this).children('.dropdown').stop(true,false,true).slideToggle(500);
        $(this).find('.chev').toggleClass('rotate');
    });
}
else{
    $('.has-child.hover').click(function() {
        $('.has-child').not($(this)).find('.dropdown').stop(true,false,true).slideUp(500);
        $('.has-child').not($(this)).find('.chev').removeClass('rotate');
        $(this).children('.dropdown').stop(true,false,true).slideToggle(500);
        $(this).find('.chev').toggleClass('rotate');
    });
}

$('.has-child.click').click(function() {
    $('.has-child').not($(this)).find('.dropdown').stop(true,false,true).slideUp(500);
    $('.has-child').not($(this)).find('.chev').removeClass('rotate');

    $(this).find('.dropdown').stop(true,false,true).slideToggle(500);
    $(this).find('.chev').toggleClass('rotate');

});

$('.slick-center').slick({
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 1,
 
  });


  // counter
$(window).on("scroll", function (e) {
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "");
    }

    if($('.goto').length > 0){
        if ($(window).scrollTop() >= $(".goto").offset().top - $(window).height()) {
           
            if (!$(".goto").hasClass("animated")) {
                $(".count").each(function () {
                    $(this)
                        .prop("Counter", 0)
                        .animate(
                            {
                                Counter: $(this).text(),
                            },
                            {
                                duration: 4000,
                                easing: "swing",
                                step: function (now) {
                                    $(this).text(numberWithCommas(Math.ceil(now)));
                                },
                            }
                        );
                });
                // $("#triggered").addClass("show");
                $(".goto").addClass("animated");
            }
        }
    }
});


$(document).ready(function(){

    var current_fs, next_fs, previous_fs; //fieldsets
    var opacity;
    var current = 1;
    var steps = $("fieldset").length;
    
    setProgressBar(current);
    
    $(".next").click(function(){
    
    current_fs = $(this).parent();
    next_fs = $(this).parent().next();
    
    //Add Class Active
    $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");
    
    //show the next fieldset
    next_fs.show();
    //hide the current fieldset with style
    current_fs.animate({opacity: 0}, {
    step: function(now) {
    // for making fielset appear animation
    opacity = 1 - now;
    
    current_fs.css({
    'display': 'none',
    'position': 'relative'
    });
    next_fs.css({'opacity': opacity});
    },
    duration: 500
    });
    setProgressBar(++current);
    });
    
    $(".previous").click(function(){
    
    current_fs = $(this).parent();
    previous_fs = $(this).parent().prev();
    
    //Remove class active
    $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");
    
    //show the previous fieldset
    previous_fs.show();
    
    //hide the current fieldset with style
    current_fs.animate({opacity: 0}, {
    step: function(now) {
    // for making fielset appear animation
    opacity = 1 - now;
    
    current_fs.css({
    'display': 'none',
    'position': 'relative'
    });
    previous_fs.css({'opacity': opacity});
    },
    duration: 500
    });
    setProgressBar(--current);
    });
    
    function setProgressBar(curStep){
    var percent = parseFloat(100 / steps) * curStep;
    percent = percent.toFixed();
    $(".progress-bar")
    .css("width",percent+"%")
    }
    
    $(".submit").click(function(){
    return false;
    })
    
    });$(document).ready(function(){

        var current_fs, next_fs, previous_fs; //fieldsets
        var opacity;
        var current = 1;
        var steps = $("fieldset").length;
        
        setProgressBar(current);
        
        $(".next").click(function(){
        
        current_fs = $(this).parent();
        next_fs = $(this).parent().next();
        
        //Add Class Active
        $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");
        
        //show the next fieldset
        next_fs.show();
        //hide the current fieldset with style
        current_fs.animate({opacity: 0}, {
        step: function(now) {
        // for making fielset appear animation
        opacity = 1 - now;
        
        current_fs.css({
        'display': 'none',
        'position': 'relative'
        });
        next_fs.css({'opacity': opacity});
        },
        duration: 500
        });
        setProgressBar(++current);
        });
        
        $(".previous").click(function(){
        
        current_fs = $(this).parent();
        previous_fs = $(this).parent().prev();
        
        //Remove class active
        $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");
        
        //show the previous fieldset
        previous_fs.show();
        
        //hide the current fieldset with style
        current_fs.animate({opacity: 0}, {
        step: function(now) {
        // for making fielset appear animation
        opacity = 1 - now;
        
        current_fs.css({
        'display': 'none',
        'position': 'relative'
        });
        previous_fs.css({'opacity': opacity});
        },
        duration: 500
        });
        setProgressBar(--current);
        });
        
        function setProgressBar(curStep){
        var percent = parseFloat(100 / steps) * curStep;
        percent = percent.toFixed();
        $(".progress-bar")
        .css("width",percent+"%")
        }
        
        $(".submit").click(function(){
        return false;
        })
        
        });

// Quantity
(function () {

    window.inputNumber = function (el) {
  
      var min = el.attr('min') || false;
      var max = el.attr('max') || false;
  
      var els = {};
  
      els.dec = el.prev();
      els.inc = el.next();
  
      el.each(function () {
        init($(this));
      });
  
      function init(el) {
  
        els.dec.on('click', decrement);
        els.inc.on('click', increment);
  
        function decrement() {
          var value = el[0].value;
          value--;
          if (!min || value >= min) {
            el[0].value = value;
          }
        }
  
        function increment() {
          var value = el[0].value;
          value++;
          if (!max || value <= max) {
            el[0].value = value++;
          }
        }
      }
    }
  })();
  
  inputNumber($('.input-number'));


$(document).ready(function(){
    var slider = $('.press-slider');

    // Function to check if an element is in viewport
    function isElementInViewport(el) {
        var rect = el[0].getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.bottom <= $(window).height()
        );
    }

    // Function to autoplay the slider
    function autoplaySlider() {
        if (isElementInViewport(slider)) {
            slider.slick('slickPlay');
        } else {
            slider.slick('slickPause');
        }
    }

    // Autoplay slider when the page loads
    slider.on('init', function(){
        slider.slick('slickGoTo', 3); // Go to slide 5 (index is zero-based)
        autoplaySlider();
    });

    // Autoplay slider when scrolling
    $(window).on('scroll', function() {
        autoplaySlider();
    });
});